/**
 * Custom domain constants with zero dependencies (mirrors `testIds.ts`'s pattern) — safe to
 * import from a Node/Playwright context that cannot load the module's React component tree
 * (`@modules/custom-domains` and `@modules/custom-domains/hooks/useCustomDomain` both pull in
 * JSX/ESM-only chains that fail under the E2E ts-node loader).
 */

/** Polling interval in milliseconds (30 seconds) `useCustomDomain` re-polls a transitional
 * domain status at. Single source of truth — `useCustomDomain.ts` imports this rather than
 * defining its own copy, so an E2E poll-cadence budget (AC-060, `domain-drawer.spec.ts`) can
 * import the real value without dragging in the rest of the module. */
export const POLL_INTERVAL = 30_000;
